module.exports = __webpack_public_path__ + "img/pin-sapphire.f6aa5339.png";